import React from 'react';
import { Icon } from './Icon.js';
export const IconRectLayoutGridFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M8.5,5.5h8v-.75c0-1.517-1.233-2.75-2.75-2.75h-5.25v3.5Z", fill: "currentColor" }),
        React.createElement("rect", { x: "8.5", y: "7", width: "8", height: "4", fill: "currentColor" }),
        React.createElement("path", { d: "M7,2h-2.75c-1.517,0-2.75,1.233-2.75,2.75V13.25c0,1.517,1.233,2.75,2.75,2.75h2.75V2Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M8.5,12.5v3.5h5.25c1.517,0,2.75-1.233,2.75-2.75v-.75H8.5Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconRectLayoutGridFill18.js.map